<template>
  <div class="offline-notice" :class="$theme.darkTheme ? 'offline-notice--dark' : 'offline-notice--light'">
    <div class="offline-notice__badge" :style="{ color: $theme.primaryColor, borderColor: $theme.primaryColor }">
      <i class="material-icons">{{ icon }}</i>
    </div>
    <div class="offline-notice__text">
      <h3 class="offline-notice__title">
        {{ title }}
      </h3>
      <p class="offline-notice__msg">
        {{ message }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "OfflineUnavailableNotice",
  props: {
    title: {
      type: String,
      default: "Conteúdo indisponível offline",
    },
    message: {
      type: String,
      default: "Conecte-se à internet para acessar.",
    },
    icon: {
      type: String,
      default: "wifi_off",
    },
  },
};
</script>

<style scoped lang="scss">
.offline-notice {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 14px;
  max-width: 360px;
  margin: 40px auto;
  padding: 40px 28px;
  border-radius: 16px;

  &--light {
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.06);
  }
  &--dark {
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.08);
  }

  &__badge {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid;
    background: rgba(128, 128, 128, 0.06);

    .material-icons {
      font-size: 34px;
    }
  }

  &__title {
    margin: 0;
    font-size: 17px;
    font-weight: 500;
    line-height: 1.3;

    .offline-notice--light & {
      color: #333333;
    }
    .offline-notice--dark & {
      color: #ffffff;
    }
  }

  &__msg {
    margin: 0;
    font-size: 14px;
    line-height: 1.5;

    .offline-notice--light & {
      color: #6b6b6b;
    }
    .offline-notice--dark & {
      color: #bfbfbf;
    }
  }
}
</style>
